import React from 'react';
import useWindowDimensions from "../../hook/useWindowDimension";

const Footer = () => {
    const {width} = useWindowDimensions()
    return (
        <div className={"footer"}>
            <ul>
                <li>
                    <h3>Notre mission</h3>
                    <p>Démocratiser l'accompagnement des aidants au service d'un proche fragilisé.</p>
                </li>
                <li>
                    <h3>Liens légaux</h3>
                    <a href={`https://www.prevandcare.com/legals-mentions.php`} target={"_blank"}>Mentions légales</a>
                    <a href={`https://www.prevandcare.com/legals-cgu.php`} target={"_blank"}>
                        {width > 620
                            ? "Conditions générales d'utilisation"
                            : "CGU"
                        }
                    </a>
                    <a href={`https://www.prevandcare.com/legals-rgpd.php`} target={"_blank"}>Politique de
                        confidentialité</a>
                </li>
                <li>
                    <h3>Nous contacter</h3>
                    <p>Une question ? Une remarque ? Envie de nous faire part d’une idée, d’une envie ?
                        <br/>N’hésitez pas à nous écrire par mail à <a
                            href={"mailto:contact@prevandcare.com"}>contact@prevandcare.com</a> ou par téléphone au <a
                            href={"tel:+33176390948"}>01.76.39.09.48</a>.
                        <br/>Nous serons ravis de vous lire !
                        <br/>À très vite !</p>
                </li>
            </ul>
        </div>
    );
};

export default Footer;